import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
// import GroupIcon from "@mui/icons-material/Group";
import { HttpStatusCode } from "axios";
import { ApplicationContext } from "../../../context/application_ctx";
// import { ModuleType } from "../../../constants";
import { GlobalSnackBar } from "../../../components/snackBar";
import { Header } from "../../../components/header";
import { theme } from "../../../styles/theme";
import { AdminDashBoard } from "../adminDashboard";
import { useNavigate } from "react-router-dom";
import {
  getAdminList,
  organizationList,
  referalList_Api,
  userDetailsAdmin,
} from "../../../api/controllers/adminController";
import { TableReadOnly } from "../../userOnBoarding/tableReadOnly";
import { Drawer } from "@mui/material";

export const AdminDashboardLayout = () => {
  // context
  const {
    reloadProfile,
    profileDetails,
    dashboardQuery,
    profileSnack,
    setProfileSnack,
    error,
    activeTab,
    setActiveTab,
    setOrganisationList,
    setProfileDetails,
    setAdminList,
    setEmployeesList,
    setFilteredList,
    setLicenceBatchList,
    employeesList,
    filteredList,
    licenceBatchList,
    filterOrgList,
    setFilterOrgList,
    referalList, setReferalList,
    adminProfileDetail, setAdminProfileDetail
  } = useContext(ApplicationContext);
  const [adminDock, setAdminDock] = useState(false);
  const navigate = useNavigate();

  console.log(activeTab, "active page");

  // let navItems = [
  //   {
  //     label: " Dashboard",
  //     icon: (
  //       <GroupIcon
  //         sx={{
  //           color:
  //             activeTab === ModuleType?.organisationDashboard
  //               ? theme.col_2
  //               : theme.col_4,
  //           // fontSize: "33px",
  //         }}
  //         // activeTab={activeTab}
  //       />
  //     ),
  //   },
  //   // {
  //   //   label: "On-boarding",
  //   //   icon: (
  //   //     <GroupIcon
  //   //       sx={{
  //   //         color: activeTab === ModuleType?.onBoarding ? theme.col_2 : theme.col_4,
  //   //         // fontSize: "33px",
  //   //       }}
  //   //     // activeTab={activeTab}

  //   //     />)
  //   // },
  //   // {
  //   //   label: "Profile",
  //   //   icon: (
  //   //     <AccountCircleIcon
  //   //       sx={{
  //   //         color: activeTab === ModuleType?.profile ? theme.col_2 : theme.col_4,
  //   //         // fontSize: "33px",
  //   //       }}
  //   //     // activeTab={activeTab}
  //   //     />
  //   //   ),
  //   // },
  //   // {
  //   //   label: "Licence",
  //   //   icon: (
  //   //     <LicenseIcon
  //   //       // sx={{
  //   //       //   color: activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4,
  //   //       //   fontSize: "33px",
  //   //       // }}
  //   //       fontSize={32}
  //   //       activeTab={activeTab}
  //   //     />
  //   //   ),
  //   // },
  //   // {
  //   //   label: "User Profile",
  //   //   icon: (
  //   //     <AccountCircleIcon
  //   //       sx={{
  //   //         color: activeTab === ModuleType?.userProfile ? theme.col_2 : theme.col_4,
  //   //         // fontSize: "33px",
  //   //       }}
  //   //     // activeTab={activeTab}
  //   //     />
  //   //   ),

  //   // },
  //   // {
  //   //   label: "Company Profile",
  //   //   icon: (
  //   //     <AccountCircleIcon
  //   //       sx={{
  //   //         color: activeTab === ModuleType?.organisationProfile ? theme.col_2 : theme.col_4,
  //   //         // fontSize: "33px",
  //   //       }}
  //   //     // activeTab={activeTab}
  //   //     />
  //   //   ),

  //   // },

  //   // {
  //   //   label: "Users",
  //   //   icon: (
  //   //     <PersonIcon
  //   //       sx={{
  //   //         color: activeTab === 3 ? theme.col_2 : theme.col_4,
  //   //         fontSize: "33px",
  //   //       }}
  //   //       activeTab={activeTab}
  //   //     />
  //   //   ),
  //   // },
  // ];

  useEffect(() => {
    if (!localStorage.getItem("api-token")) {
      navigate("/admin-signin");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getDetails = async () => {
      try {
        let response = await userDetailsAdmin();
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          setProfileDetails(response.data);
          setAdminProfileDetail(response.data);
          getReferal(response.data)
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/admin-signin");
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getOrganisations = async () => {
      try {
        let response = await organizationList();
        console.log(response, "list");
        if (response.status === HttpStatusCode.Ok) {
          setOrganisationList(response.data);
          setFilterOrgList(response.data);
          // setEmployeesList(response.data);
          // setFilteredList(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getReferal = async (data) => {
      console.log("listReferal");

      try {
        let response = await referalList_Api(data?.email);
        console.log(response, "listReferal");
        if (response.status === HttpStatusCode.Ok) {
          setReferalList(response.data?.users);
          // setFilteredList(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getList = async () => {
      try {
        let response = await getAdminList();
        if (response.status === HttpStatusCode.Ok) {
          setAdminList(response.data);
        }
        console.log(response, "list");
      } catch (error) {
        console.log(error);
      }
    };

    getList();
    getDetails();
    getOrganisations();
  }, [reloadProfile]); // eslint-disable-line react-hooks/exhaustive-deps

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };

  return (
    <>
      <Box display="flex" width="100vw" height="100vh" overflow="hidden">
        {/* {dashboardQuery ? (
          <></>
        ) : (
          <NavigationDock admin={true} navItems={navItems} />
        )} */}
        <Box
          display="flex"
          width={dashboardQuery ? "100%" : "100%"}
          height="100%"
          justifyContent="center"
          backgroundColor={theme.col_7}
        >
          <Box
            flex="1"
            display="flex"
            flexDirection="column"
            gap={2}
            padding={dashboardQuery ? "10px" : "0px 12px"}
            paddingBottom={dashboardQuery ? "3px" : "50px"}
            overflow="auto"
          >
            <Header
              setAdminDock={setAdminDock}
              admin={true}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              dashboardQuery={dashboardQuery}
              adminProfileDetail={adminProfileDetail}
            />
            <ActiveModule
              setAdminDock={setAdminDock}
              adminDock={adminDock}
              profileDetails={profileDetails}
              dashboardQuery={dashboardQuery}
              activeTab={activeTab}
            />
            {/* <TableReadOnly/> */}
            {/* {dashboardQuery ? <BottomNavBar navItems={navItems} /> : <></>} */}
          </Box>
        </Box>
      </Box>

      {/* <SubscriptionDialog
        upgrade={true}
        demoExpired={true}
      /> */}
      {/* <WelcomeDialog /> */}
      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
    </>
  );
};

export const ActiveModule = ({ activeTab, setAdminDock, adminDock }) => {
  switch (0) {
    case 0:
      return (
        <AdminDashBoard setAdminDock={setAdminDock} adminDock={adminDock} />
      );
    // // return null;

    // case ModuleType.onBoarding:
    //   return <UserProfile />;
    // // return <OnBoardingTable />

    // case ModuleType.profile:
    //   // return <Profile />
    //   return null;

    // case ModuleType.userProfile:
    //   return <UserProfileDetail />

    // case ModuleType.licence:
    //   return <Licence />

    // case ModuleType.organisationProfile:
    //   return <OrganisationProfileDetail />

    default:
      return;
  }
};
